import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep8 = (state) => state.get('step8');

const makeSelectStep8 = () =>
  createSelector(selectStep8, (step8State) => ({
    areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses: mapWithDefault(
      step8State,
      () =>
        step8State.getIn([
          'form',
          'areYouClaimingForOverseasEmergencyMedicalOrDentalExpenses',
        ]),
      ''
    ),
    areYouClaimingForOverseas247: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForOverseas247']),
      ''
    ),
    areYouClaimingForEmergencyMedicalAndHospitalExpenses: mapWithDefault(
      step8State,
      () =>
        step8State.getIn([
          'form',
          'areYouClaimingForEmergencyMedicalAndHospitalExpenses',
        ]),
      ''
    ),
    areYouClaimingForEmergencyDental: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForEmergencyDental']),
      ''
    ),
    areYouClaimingForEmergencyEvacuation: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForEmergencyEvacuation']),
      ''
    ),
    areYouClaimingForHospitalCashPayment: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForHospitalCashPayment']),
      ''
    ),
    areYouClaimingForAccidentalDeath: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForAccidentalDeath']),
      ''
    ),
    areYouClaimingForPermanentDisability: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForPermanentDisability']),
      ''
    ),
    areYouClaimingForLossOfIncome: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'areYouClaimingForLossOfIncome']),
      ''
    ),
    patientName: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'patientName']),
      ''
    ),
    relationshipToYou: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'relationshipToYou']),
      ''
    ),
    patientDateOfBirth: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'patientDateOfBirth']),
      ''
    ),
    medicareNumber: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'medicareNumber']),
      ''
    ),
    whatIsYourInjuryOrIllness: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'whatIsYourInjuryOrIllness']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivity: mapWithDefault(
      step8State,
      () =>
        step8State.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivity',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatient: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'wasTheInufredIllTravallerAnInpatient']),
      ''
    ),
    dateOfAdmission: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfAdmission']),
      ''
    ),
    timeOfAdmission: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfAdmission']),
      ''
    ),
    dateOfDischarge: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfDischarge']),
      ''
    ),
    timeOfDischarge: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfDischarge']),
      ''
    ),
    contactEmergencyAssistance: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'contactEmergencyAssistance']),
      ''
    ),
    assistanceCaseReferenceNumber: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'assistanceCaseReferenceNumber']),
      ''
    ),
    dateOfFirstMedicalConsultation: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfFirstMedicalConsultation']),
      ''
    ),
    hasInjuredOrIllTravellerPreviously: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'hasInjuredOrIllTravellerPreviously']),
      ''
    ),
    medicalExpenses: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'medicalExpenses']).toJS(),
      ''
    ),
    awareOfAnyMedicalConditions: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'awareOfAnyMedicalConditions']),
      ''
    ),
    underInvestigation: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'underInvestigation']),
      ''
    ),
    haveMedicalConditionOrComplication: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'haveMedicalConditionOrComplication']),
      ''
    ),
    giveATerminalPrognosis: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'giveATerminalPrognosis']),
      ''
    ),
    travellingAgainst: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'travellingAgainst']),
      ''
    ),
    previousMedicalConditionDetails: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'previousMedicalConditionDetails']),
      ''
    ),
    plannedReturnToWorkDate: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'plannedReturnToWorkDate']),
      ''
    ),
    actualReturnToWorkDate: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'actualReturnToWorkDate']),
      ''
    ),
    incomeLost: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'incomeLost']),
      ''
    ),
    insuredName: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'insuredName']),
      ''
    ),
    insuredDateOfDeath: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'insuredDateOfDeath']),
      ''
    ),
    relationshipToYouAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'relationshipToYouAD']),
      ''
    ),
    whatIsYourInjuryOrIllnessAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'whatIsYourInjuryOrIllnessAD']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivityAD: mapWithDefault(
      step8State,
      () =>
        step8State.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivityAD',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatientAD: mapWithDefault(
      step8State,
      () =>
        step8State.getIn(['form', 'wasTheInufredIllTravallerAnInpatientAD']),
      ''
    ),
    dateOfAdmissionAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfAdmissionAD']),
      ''
    ),
    timeOfAdmissionAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfAdmissionAD']),
      ''
    ),
    dateOfDischargeAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfDischargeAD']),
      ''
    ),
    timeOfDischargeAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfDischargeAD']),
      ''
    ),
    nameOfPractitionerDentistHospitalAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'nameOfPractitionerDentistHospitalAD']),
      ''
    ),
    contactEmergencyAssistanceAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'contactEmergencyAssistanceAD']),
      ''
    ),
    assistanceCaseReferenceNumberAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'assistanceCaseReferenceNumberAD']),
      ''
    ),
    dateOfFirstMedicalConsultationAD: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfFirstMedicalConsultationAD']),
      ''
    ),
    patientNameLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'patientNameLI']),
      ''
    ),
    relationshipToYouLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'relationshipToYouLI']),
      ''
    ),
    patientDateOfBirthLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'patientDateOfBirthLI']),
      ''
    ),
    medicareNumberLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'medicareNumberLI']),
      ''
    ),
    whatIsYourInjuryOrIllnessLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'whatIsYourInjuryOrIllnessLI']),
      ''
    ),
    didThisOccurWhilstEngagingInSnowSportActivityLI: mapWithDefault(
      step8State,
      () =>
        step8State.getIn([
          'form',
          'didThisOccurWhilstEngagingInSnowSportActivityLI',
        ]),
      ''
    ),
    wasTheInufredIllTravallerAnInpatientLI: mapWithDefault(
      step8State,
      () =>
        step8State.getIn(['form', 'wasTheInufredIllTravallerAnInpatientLI']),
      ''
    ),
    dateOfAdmissionLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfAdmissionLI']),
      ''
    ),
    timeOfAdmissionLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfAdmissionLI']),
      ''
    ),
    dateOfDischargeLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfDischargeLI']),
      ''
    ),
    timeOfDischargeLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'timeOfDischargeLI']),
      ''
    ),
    nameOfPractitionerDentistHospitalLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'nameOfPractitionerDentistHospitalLI']),
      ''
    ),
    contactEmergencyAssistanceLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'contactEmergencyAssistanceLI']),
      ''
    ),
    assistanceCaseReferenceNumberLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'assistanceCaseReferenceNumberLI']),
      ''
    ),
    dateOfFirstMedicalConsultationLI: mapWithDefault(
      step8State,
      () => step8State.getIn(['form', 'dateOfFirstMedicalConsultationLI']),
      ''
    ),
  }));

const makeSelectStep8Errors = () =>
  createSelector(selectStep8, (state) => state.get('errors'));

export { makeSelectStep8, makeSelectStep8Errors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step8/selectors.js